import React, { type FC } from 'react';
import { connect } from 'react-redux';

import type { ReduxState } from 'app/redux/types';

import { BettingWrapper, Skeleton } from 'app/modules/Betting';

import $betting from '../../contexts/betting/$prematch';
import { currentLocation } from '../Navigation/selectors';
import { Content } from './components/Content';
import { entityLoading, entityRequested } from './selectors/gridEntities';

type StoreProps = {
  matchId: number | null;
  loading: boolean;
  requested: boolean;
};

const Prematch: FC<StoreProps> = ({ matchId, loading, requested }) => {
  if (!requested && loading && !matchId) {
    return (
      <Skeleton />
    );
  }

  return (
    <BettingWrapper context={$betting}>
      <Content />
    </BettingWrapper>
  );
};

const mapStateToProps = (state: ReduxState) => {
  const location = currentLocation(state);

  return ({
    loading: entityLoading(state),
    requested: entityRequested(state),
    matchId: location.matchId,
  });
};

export default connect(mapStateToProps)(Prematch);
